/**
 * Centralised query key factory.
 * Every future feature adds a key here.
 * The nested array structure lets you invalidate whole slices:
 *   queryClient.invalidateQueries({ queryKey: ['entries', userId] })
 *   invalidates all years at once.
 */
export const queryKeys = {
  categories:    (userId: string) => ['categories', userId] as const,
  entries: (userId: string, range: string) => ['entries', userId, range] as const,
  wheelSections: (userId: string) => ['wheel-sections', userId] as const,
  todos: (userId: string, range = 'all') => ['todos', userId, range] as const,
  wheelNotes:    (userId: string) => ['wheel-notes', userId] as const,
  userPreferences: (userId: string) => ['user-preferences', userId] as const,
  gcalStatus:  (userId: string) => ['gcal-status', userId] as const,
  gcalEvents:  (userId: string, date: string) => ['gcal-events', userId, date] as const,
} as const;
